export default __webpack_public_path__ + "static/img2-8d0380a54f8587e55a0ba8160b917b91.jpg";